module.exports = __webpack_public_path__ + "img/007.b8415197.png";